import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody24 from '../component/Casestudybody24';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy24 = ({setBlank}) => {
         
    // const headings = "<h4  style='display:inline-block;color:#ffffff;'>Periodic</h4><h2 style='display:inline-block;color:#ffffff;'>  Portfolio Performance Review</h2><h4>For a US-based PE firm</h4>";
    // const headings = "<h4  style='display:inline-block;color:#ffffff;margin-right:10px;'>Periodic </h4><h2 style='display:inline-block;color:#ffffff;'>  Portfolio Performance</h2><br><h2 style='display:inline-block;color:#ffffff;margin-right:10px;'>Review </h2><h4 style='display:inline-block;color:#ffffff;'>For a US-based PE firm</h4>";
    const headings = "<h2 style='display:inline-block;color:#ffffff;'> Enabling Sector Understanding</h2><h4> Through WACC Benchmarking</h4>";
  return (
    <>
        <Helmet>
          <title>Enabling Sector Understanding Through WACC Benchmarking</title>
          <meta property="og:title" content="Enabling Sector Understanding Through WACC Benchmarking" />
          <meta property='og:description' content='Enabling Sector Understanding Through WACC Benchmarking'/>
          <meta name='keywords' content=''/>
        </Helmet>
        <Menu setBlank={setBlank}  />
        <HeaderCasestudy headings={headings} class="header-casestudy24" />  
        <Casestudybody24 />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy24
